import React from "react";
import { useTranslation } from "react-i18next";

function AccountCreatePage() {

    var { t } = useTranslation();

    const [isOrganization, setIsOrganization] = React.useState(false);

    function handleFormSubmit(event) {
        event.preventDefault(); // prevents default browser submission

        var formData = new FormData(event.target);

        var isOrg = formData.get("isOrganization") === "on";

        var userObject = {
            login: formData.get("login"),
            name: formData.get("name"),
            surname: formData.get("surname"),
            isOrganization: isOrg,
            email: formData.get("email"),
            phoneNumber: formData.get("phoneNumber"),
            password: formData.get("password"),
            cityOfOrigin: formData.get("cityOfOrigin"),
            age: formData.get("age") ? parseInt(formData.get("age")) : undefined,
            educationLevel: formData.get("educationLevel"),
            role: isOrg ? "employer" : "user"
        };

        fetch("https://api.jai.com.kz/api/user/create",
            {
                method: "POST",
                headers:
                {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(userObject)
            })
            .then(async function (response) {
                if (!response.ok) {
                    // Try to parse the error message from the server
                    const errorData = await response.json().catch(() => null);
                    const errorMessage = errorData && errorData.error ? errorData.error : `HTTP status ${response.status}`;
                    throw new Error(errorMessage);
                }

                return response.json();
            })
            .then(function (data) {
                console.log("Success:", data);
                window.UIkit.notification({
                    message: data.message || "Account created successfully!",
                    status: "success",
                    pos: "bottom-right",
                    timeout: 5000
                });

                // Optionally, you can redirect the user after a delay
                // For example, to the login page
                // setTimeout(() => {
                //     window.location.href = '/login';
                // }, 5000);
            })
            .catch(function (error) {
                console.error("Error:", error);
                window.UIkit.notification({
                    message: "Error: " + error.message,
                    status: "danger",
                    pos: "bottom-right",
                    timeout: 5000
                });
            });
    }

    return (
        <div>
            <div className="uk-container uk-margin-small-top">
                <div className="uk-card uk-card-default uk-card-body uk-box-shadow-medium uk-border-rounded">
                    <h2 className="uk-card-title uk-text-center uk-margin">
                        Create New Account
                    </h2>

                    <form onSubmit={handleFormSubmit} className="uk-form-stacked">

                        <div className="uk-margin uk-grid-small uk-child-width-auto" data-uk-grid>
                            <label>
                                <input
                                    className="uk-checkbox"
                                    id="isOrganization"
                                    name="isOrganization"
                                    type="checkbox"
                                    onChange={(e) => setIsOrganization(e.target.checked)}
                                /> Is this account is for Kazakhstani company willing to employ foreign individuals?
                            </label>
                        </div>

                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="name">
                                {isOrganization ? "Company Name" : "First Name"}
                            </label>
                            <div className="uk-form-controls">
                                <input
                                    className="uk-input"
                                    id="name"
                                    name="name"
                                    type="text"
                                    required
                                />
                            </div>
                        </div>

                        {/* This has to be 4-20 characters long, no special symbols, only "_" (underscore), A-Z, a-z and 0-9 characters */}
                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="name">
                                Create login or nickname
                            </label>
                            <div className="uk-form-controls">
                                <input
                                    className="uk-input"
                                    id="login"
                                    name="login"
                                    type="text"
                                    required
                                    minLength="4"
                                    maxLength="20"
                                    pattern="[A-Za-z0-9_]+"
                                    title="Must be 4-20 characters and can only contain letters, numbers, and underscores."
                                />
                            </div>
                        </div>

                        {!isOrganization && (
                            <div className="uk-margin">
                                <label className="uk-form-label" htmlFor="surname">
                                    Surname
                                </label>
                                <div className="uk-form-controls">
                                    <input
                                        className="uk-input"
                                        id="surname"
                                        name="surname"
                                        type="text"
                                    />
                                </div>
                            </div>
                        )}

                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="email">
                                Email
                            </label>
                            <div className="uk-form-controls">
                                <input
                                    className="uk-input"
                                    id="email"
                                    name="email"
                                    type="email"
                                    required
                                />
                            </div>
                        </div>

                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="phoneNumber">
                                Phone Number (include +)
                            </label>
                            <div className="uk-form-controls">
                                <input
                                    className="uk-input"
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    type="text"
                                    required
                                />
                            </div>
                        </div>

                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="password">
                                Password
                            </label>
                            <div className="uk-form-controls">
                                <input
                                    className="uk-input"
                                    id="password"
                                    name="password"
                                    type="password"
                                    required
                                />
                            </div>
                        </div>

                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="cityOfOrigin">
                                City of Origin
                            </label>
                            <div className="uk-form-controls">
                                <input
                                    className="uk-input"
                                    id="cityOfOrigin"
                                    name="cityOfOrigin"
                                    type="text"
                                />
                            </div>
                        </div>

                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="age">
                                Age
                            </label>
                            <div className="uk-form-controls">
                                <input
                                    className="uk-input"
                                    id="age"
                                    name="age"
                                    type="number"
                                    min="0"
                                />
                            </div>
                        </div>

                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="educationLevel">
                                Education Level
                            </label>
                            <div className="uk-form-controls">
                                <select
                                    className="uk-select"
                                    id="educationLevel"
                                    name="educationLevel"
                                >
                                    <option value="">Select</option>
                                    <option value="Zero">Zero</option>
                                    <option value="Elementary School">Elementary School</option>
                                    <option value="High School">High School</option>
                                    <option value="Bachelor">Bachelor</option>
                                    <option value="Master">Master</option>
                                    <option value="PhD">PhD</option>
                                </select>
                            </div>
                        </div> 

                        <div className="uk-margin uk-text-center">
                            <button
                                type="submit"
                                className="uk-button uk-button-primary uk-button-jai"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AccountCreatePage;
